import type { FlavorsSelection } from "@jti/fe-common";

import type { StickProductAggregations } from "../../../../containers/SticksProductDetailsContainer/types";

export const handleSinglePacksTransition = (
  aggregation: StickProductAggregations | undefined,
  setSelectedFlavors: (flavors: FlavorsSelection) => void,
  handleTransitionFromSubscriptionToSinglePacks: (sku?: string) => void
) => {
  setSelectedFlavors({});
  const lastSingleProductSku = aggregation?.onetime?.single_packs?.sku;
  handleTransitionFromSubscriptionToSinglePacks(lastSingleProductSku);
};
